import script from "./Buttons.vue?vue&type=script&setup=true&lang=js"
export * from "./Buttons.vue?vue&type=script&setup=true&lang=js"

import "./Buttons.vue?vue&type=style&index=0&id=5ca0ea56&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca0ea56"]])

export default __exports__